import React from 'react';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Comprende su Mente',
    desc: "Descarga el manual y lee la sección 'El Cerebro bajo Presión' para entender qué siente tu hijo."
  }, {
    num: '2',
    title: 'Enseña el Reset',
    desc: "Enseña a tu hijo el gesto de 'Reset' y su Palabra de Poder antes del próximo entrenamiento."
  }, {
    num: '3',
    title: 'Transforma el Viaje',
    desc: "Aplica la 'Regla de los 20 Minutos' en el próximo viaje de regreso del partido y observa cómo cambia la dinámica familiar."
  }];
  return <section className="py-24 px-4 bg-warm-light" data-id="element-85">
      <div className="max-w-4xl mx-auto" data-id="element-86">
        <h2 className="text-4xl md:text-5xl font-black text-center text-warm-dark mb-16" data-id="element-87">
          Cómo Funciona en 3 Pasos
        </h2>

        <div className="space-y-12" data-id="element-88">
          {steps.map((step, index) => <div key={index} className="flex gap-8 items-start" data-id="element-89">
              <div className="font-heading text-6xl font-black text-warm-dark/15 leading-none shrink-0 w-20 text-right" data-id="element-90">
                {step.num}
              </div>
              <div className="pt-2 border-t border-warm-dark/10 flex-1" data-id="element-91">
                <h3 className="text-2xl font-heading font-bold text-warm-dark mb-2" data-id="element-92">
                  {step.title}
                </h3>
                <p className="text-warm-mid leading-relaxed" data-id="element-93">{step.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}